angular.module('aprima-provider-api').factory('VisitLocker',
    ['Locker',
        function (Locker) {
            'use strict';

            function VisitLocker(visit, $scope, lockType, visitId) {
                Locker.call(this, visit, $scope, lockType || 'VisitNote', visitId, 'Visit');
            }

            VisitLocker.prototype = Object.create(Locker.prototype, {});
            VisitLocker.prototype.constructor = VisitLocker;

            return VisitLocker;
        }]);